import React, { useState, useRef, useEffect } from "react";

const WhyChooseUsSection = () => {
  const [open, setOpen] = useState(null);
  const [heights, setHeights] = useState({});
  const contentRefs = useRef({});

  const items = [
    {
      title: "End-to-End Digital Solutions",
      content:
        "We deliver a complete range of digital services—from tailored website design to SEO and digital marketing—customized to your business goals to boost growth and strengthen your online presence.",
    },
    {
      title: "Experienced Professionals You Can Trust",
      content:
        "Each member of our team brings more than three years of hands-on industry experience, combining strong technical skills with innovative thinking to deliver impactful solutions and long-term business value.",
    },
    {
      title: "Cost-Effective, High-Quality Services",
      content:
        "We offer flexible, high-value digital services that combine quality and affordability. From development to marketing, our solutions help businesses grow efficiently while keeping costs competitive.",
    },
    {
      title: "A Record of Excellence and Achievement",
      content:
        "Our cross-industry expertise proves our capability to drive digital growth and meaningful results. We value long-term collaboration and take pride in a history of happy, loyal clients.",
    },
  ];

  // Measure content heights on mount and when content changes
  useEffect(() => {
    const newHeights = {};
    items.forEach((_, index) => {
      const element = contentRefs.current[index];
      if (element) {
        newHeights[index] = element.scrollHeight;
      }
    });
    setHeights(newHeights);
  }, []);

  const handleToggle = (index) => {
    setOpen(open === index ? null : index);
  };

  return (
    <section className="w-full bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 sm:py-20 space-y-20">
        {/* ===== Our Commitment ===== */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Image */}
          <div className="flex justify-center lg:justify-start">
            <img
              src="/assets/our-commitment.webp"
              alt="Team commitment"
              className="w-full max-w-sm sm:max-w-md rounded-2xl object-cover aspect-[4/5]"
            />
          </div>

          {/* Card Content */}
          <div className="bg-white rounded-xl shadow-[0_8px_24px_rgba(0,0,0,0.18)] p-6 sm:p-8 lg:p-10">
            <h3 className="text-xl sm:text-2xl font-semibold text-black">
              Our Commitment
            </h3>

            <p className="mt-4 text-gray-700 text-sm sm:text-base leading-7">
              Digital Transformation Associates brings together highly skilled,
              niche talent from across the global market to help organizations
              achieve sustainable success. Our mission is to combine deep
              technology expertise, strong business insight, and a dedicated
              team of experienced professionals to deliver practical and
              effective Business and IT solutions tailored to each client's
              needs.
              <br />
              <br />
              We focus on building long-term partnerships with our clients and
              leading global technology providers. From initial business process
              analysis and solution design to technology selection,
              implementation, and ongoing application support, our team remains
              fully engaged throughout the entire journey.
              <br />
              <br />
              While technology continues to evolve rapidly, our commitment to
              delivering value-driven, reliable solutions remains constant.
            </p>
          </div>
        </div>

        {/* ===== Why Choose Us ===== */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left Content */}
          <div>
            <h3 className="text-lg sm:text-xl font-semibold text-[#0b4864]">
              Why Choose Us for Your Digital Growth
            </h3>

            <p className="mt-3 text-gray-700 text-sm sm:text-base leading-7 max-w-xl">
              Digital Transformation Associates partners with businesses to
              deliver modern digital solutions that drive real impact. From
              advanced software development to strategic digital marketing, we
              design customized, innovative, and performance-focused solutions
              that help your business stand out and succeed in the digital
              landscape.
            </p>

            {/* Smooth Accordion */}
            <div className="mt-6 space-y-2 max-w-xl">
              {items.map((item, index) => (
                <div
                  key={index}
                  className="border-b border-gray-300 overflow-hidden transition-all duration-300 ease-in-out"
                  style={{
                    maxHeight:
                      open === index
                        ? `${(heights[index] || 0) + 80}px`
                        : "60px",
                  }}
                >
                  <button
                    onClick={() => handleToggle(index)}
                    className="w-full flex justify-between items-center text-left py-3"
                  >
                    <span className="font-medium text-sm sm:text-base text-black pr-4">
                      {item.title}
                    </span>
                    <span className="text-xl text-[#0b4864] flex-shrink-0 transition-transform duration-300 ease-in-out ml-2">
                      {open === index ? "−" : "+"}
                    </span>
                  </button>

                  <div
                    ref={(el) => (contentRefs.current[index] = el)}
                    className="overflow-hidden transition-all duration-300 ease-in-out"
                    style={{
                      maxHeight: open === index ? `${heights[index]}px` : "0px",
                      opacity: open === index ? 1 : 0,
                      transform:
                        open === index ? "translateY(0)" : "translateY(-10px)",
                    }}
                  >
                    <p className="pb-3 text-sm text-gray-600 leading-relaxed">
                      {item.content}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image - Unaffected by accordion */}
          <div className="flex justify-center lg:justify-end">
            <img
              src="/assets/why-choose-us.webp"
              alt="Team collaboration"
              className="w-full max-w-md rounded-2xl object-cover aspect-[4/3]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;

// import React, { useState } from "react";

// const WhyChooseUsSection = () => {
//   const [open, setOpen] = useState(null);

//   const items = [
//     {
//       title: "End-to-End Digital Solutions",
//       content:
//         "We deliver a complete range of digital services—from tailored website design to SEO and digital marketing—customized to your business goals to boost growth and strengthen your online presence.",
//     },
//     {
//       title: "Experienced Professionals You Can Trust",
//       content:
//         "Each member of our team brings more than three years of hands-on industry experience, combining strong technical skills with innovative thinking to deliver impactful solutions and long-term business value.",
//     },
//     {
//       title: "Cost-Effective, High-Quality Services",
//       content:
//         "We offer flexible, high-value digital services that combine quality and affordability. From development to marketing, our solutions help businesses grow efficiently while keeping costs competitive.",
//     },
//     {
//       title: "A Record of Excellence and Achievement",
//       content:
//         "Our cross-industry expertise proves our capability to drive digital growth and meaningful results. We value long-term collaboration and take pride in a history of happy, loyal clients.",
//     },
//   ];

//   return (
//     <section className="w-full bg-white">
//       <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 sm:py-20 space-y-20">
//         {/* ===== Our Commitment ===== */}
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
//           {/* Image */}
//           <div className="flex justify-center lg:justify-start">
//             <img
//               src="/assets/our-commitment.webp"
//               alt="Team commitment"
//               className="w-full max-w-sm sm:max-w-md rounded-2xl object-cover aspect-[4/5]"
//             />
//           </div>

//           {/* Card Content */}
//           <div className="bg-white rounded-xl shadow-[0_8px_24px_rgba(0,0,0,0.18)] p-6 sm:p-8 lg:p-10">
//             <h3 className="text-xl sm:text-2xl font-semibold text-black">
//               Our Commitment
//             </h3>

//             <p className="mt-4 text-gray-700 text-sm sm:text-base leading-7">
//               Digital Transformation Associates brings together highly skilled,
//               niche talent from across the global market to help organizations
//               achieve sustainable success. Our mission is to combine deep
//               technology expertise, strong business insight, and a dedicated
//               team of experienced professionals to deliver practical and
//               effective Business and IT solutions tailored to each client’s
//               needs.
//               <br />
//               <br />
//               We focus on building long-term partnerships with our clients and
//               leading global technology providers. From initial business process
//               analysis and solution design to technology selection,
//               implementation, and ongoing application support, our team remains
//               fully engaged throughout the entire journey.
//               <br />
//               <br />
//               While technology continues to evolve rapidly, our commitment to
//               delivering value-driven, reliable solutions remains constant.
//             </p>
//           </div>
//         </div>

//         {/* ===== Why Choose Us ===== */}
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
//           {/* Left Content */}
//           <div>
//             <h3 className="text-lg sm:text-xl font-semibold text-[#0b4864]">
//               Why Choose Us for Your Digital Growth
//             </h3>

//             <p className="mt-3 text-gray-700 text-sm sm:text-base leading-7 max-w-xl">
//               Digital Transformation Associates partners with businesses to
//               deliver modern digital solutions that drive real impact. From
//               advanced software development to strategic digital marketing, we
//               design customized, innovative, and performance-focused solutions
//               that help your business stand out and succeed in the digital
//               landscape.
//             </p>

//             {/* Accordion */}
//             <div className="mt-6 space-y-4 max-w-xl">
//               {items.map((item, index) => (
//                 <div key={index} className="border-b border-gray-300 pb-3">
//                   <button
//                     onClick={() => setOpen(open === index ? null : index)}
//                     className="w-full flex justify-between items-center text-left font-medium text-sm sm:text-base"
//                   >
//                     {item.title}
//                     <span className="text-xl">
//                       {open === index ? "−" : "+"}
//                     </span>
//                   </button>

//                   {open === index && (
//                     <p className="mt-3 text-sm text-gray-600">{item.content}</p>
//                   )}
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Right Image */}
//           <div className="flex justify-center lg:justify-end">
//             <img
//               src="/assets/why-choose-us.webp"
//               alt="Team collaboration"
//               className="w-full max-w-md rounded-2xl object-cover aspect-[4/3]"
//             />
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WhyChooseUsSection;
